'use client';

import ThumbsUp from '@/assets/svg/icons/thumbs-up';
import Pill from '@/components/pill';
import Tooltip from '@/components/tooltip';
import COLORS from '@/lib/helpers/color-helper';
import { ActionType } from '@/state/types';
import { useGlobalState } from '@/state';
import ThumbsUpBackground from '@/assets/svg/icons/thumbs-up-background';
import { Box } from '@/components/layout/box';
import { Flex } from '@/components/layout/flex';
import Text from '@/components/typography/text';

interface GoodDealBadgeProps {
  title: string;
  percentBelowAvg: number;
}
export default function GoodDealBadge({ title, percentBelowAvg }: GoodDealBadgeProps) {
  const { dispatch } = useGlobalState();

  const handleModal = () => {
    dispatch({
      type: ActionType.ADD_MODAL_DATA,
      payload: {
        title: 'Good Deal',
        component: (
          <Flex align='center'>
            <Box mb={1}>
              <ThumbsUpBackground
                height={64}
                width={64}
                fillColor={COLORS.green}
              />
            </Box>
            <Text copy align='center'>
              The price of this listing is at least {percentBelowAvg * 100}%
              below the average sale price for {title}!
            </Text>
          </Flex>
        ),
      },
    });
  };


  return (
    <Tooltip
      content={`The price of this listing is at least ${percentBelowAvg * 100}% below the average sale price for ${title}!`}
      position='top'
    >
      <Pill
        style='green'
        text={'Good Deal'}
        icon={<ThumbsUp fillColor={COLORS.green} />}
        onClick={handleModal}
      />
    </Tooltip>
  );
}